/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'element-image': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M42 8H5v32h37V8zM5 5a3 3 0 0 0-3 3v32a3 3 0 0 0 3 3h37a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H5z"/><rect pid="1" x="7" y="34.985" width="17.212" height="3" rx="1.5" transform="rotate(-45 7 34.985)"/><rect pid="2" x="19.227" y="23" width="17.212" height="3" rx="1.5" transform="rotate(45 19.227 23)"/><rect pid="3" x="21.105" y="29.17" width="17.212" height="3" rx="1.5" transform="rotate(-45 21.105 29.17)"/><rect pid="4" x="33.121" y="17" width="17.212" height="3" rx="1.5" transform="rotate(45 33.121 17)"/><path pid="5" fill-rule="evenodd" clip-rule="evenodd" d="M13.105 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 3a5 5 0 1 0 0-10 5 5 0 0 0 0 10z"/>'
  }
})
